import { Box, BoxSx } from "@modernatx-internal/ui-kit-react";
import React from "react";

export const VialImage: React.FC<{ sx?: BoxSx }> = ({ sx }) => {
  return (
    <Box
      as="svg"
      aria-hidden="true"
      sx={sx}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0.00 0.00 516.00 516.00"
    >
      <path
        fill="#03608d"
        d="   M 233.43 0.00   C 254.84 1.98 272.84 16.21 278.14 37.15   Q 279.71 43.36 279.67 55.98   Q 279.58 90.05 279.64 326.31   A 0.82 0.82 0.0 0 0 280.03 327.01   Q 307.49 343.46 320.94 372.51   C 339.41 412.39 329.03 460.55 296.58 489.84   Q 270.51 513.36 234.23 516.00   Q 234.15 516.00 234.07 516.00   Q 233.38 515.70 233.03 516.00   L 224.50 516.00   Q 186.56 514.03 160.03 489.47   C 123.55 455.70 116.24 401.45 143.24 359.37   Q 156.66 338.46 180.11 325.15   A 1.29 1.28 -14.8 0 0 180.77 324.03   Q 180.70 49.28 180.81 46.76   C 181.27 36.35 185.19 26.58 191.52 18.64   Q 204.44 2.45 226.41 0.00   L 233.43 0.00   Z   M 182.30 326.31   Q 159.86 338.41 146.17 358.61   C 111.96 409.06 130.72 478.66 186.38 504.65   C 245.28 532.16 313.97 496.65 326.21 433.21   C 334.36 391.03 314.55 349.49 278.10 328.21   A 0.94 0.93 -75.0 0 1 277.64 327.40   Q 277.58 65.05 277.68 58.83   Q 277.93 44.01 276.12 37.36   C 267.50 5.75 231.02 -8.08 203.53 10.16   C 191.70 18.01 182.74 33.12 182.74 47.51   Q 182.75 213.92 182.74 325.57   A 0.84 0.84 0.0 0 1 182.30 326.31   Z"
      />
      <rect
        fill="#079be1"
        x={-3.63}
        y={-1}
        transform="translate(306.88,76.37) rotate(0.2)"
        width={7.26}
        height={2}
        rx={0.47}
      />
      <rect fill="#079be1" x={317.62} y={75.38} width={14.34} height={2} rx={0.42} />
      <rect
        fill="#079be1"
        x={-7.19}
        y={-0.99}
        transform="translate(346.31,76.37) rotate(-0.1)"
        width={14.38}
        height={1.98}
        rx={0.43}
      />
      <rect
        fill="#079be1"
        x={-7.17}
        y={-0.99}
        transform="translate(367.79,76.37) rotate(0.1)"
        width={14.34}
        height={1.98}
        rx={0.44}
      />
      <rect
        fill="#079be1"
        x={-3.56}
        y={-1}
        transform="translate(385.69,76.37) rotate(-0.1)"
        width={7.12}
        height={2}
        rx={0.41}
      />
      <path
        fill="#addcf2"
        d="   M 243.12 143.75   L 243.12 144.46   L 243.12 145.75   L 243.12 146.46   L 243.12 147.75   L 243.12 148.46   L 243.12 149.75   L 243.12 150.46   Q 243.12 150.60 243.12 150.75   L 243.12 151.46   L 243.12 153.75   L 243.12 154.46   L 243.12 155.75   L 243.12 156.46   L 243.12 157.75   L 243.12 158.46   Q 243.12 158.60 243.12 158.75   L 243.12 159.46   L 243.12 160.75   L 243.12 161.46   L 243.12 163.75   L 243.12 164.46   L 243.12 165.75   L 243.12 166.46   L 243.12 168.75   L 243.12 169.46   L 243.12 171.75   L 243.12 172.46   L 243.12 173.75   L 243.12 174.46   Q 243.12 174.60 243.12 174.75   L 243.12 175.46   L 243.12 179.75   L 243.12 180.46   L 243.12 181.75   L 243.12 182.46   Q 243.12 182.60 243.12 182.75   L 243.12 183.46   L 243.12 185.75   L 243.12 186.46   L 243.12 187.75   L 243.12 188.46   L 243.12 189.75   L 243.12 190.46   Q 243.12 190.60 243.12 190.75   L 243.12 191.46   L 243.12 193.75   L 243.12 194.46   L 243.12 195.75   L 243.12 196.46   L 243.12 197.75   L 243.12 198.46   Q 243.12 198.60 243.12 198.75   L 243.12 199.46   L 243.12 200.75   L 243.12 201.46   L 243.12 203.75   L 243.12 204.46   L 243.12 205.75   L 243.12 206.46   Q 243.12 206.60 243.12 206.75   L 243.12 207.46   L 243.12 209.75   L 243.12 210.46   L 243.12 211.75   L 243.12 212.46   L 243.12 213.75   L 243.12 214.46   Q 243.12 214.60 243.12 214.75   L 243.12 215.46   L 243.12 216.75   L 243.12 217.46   L 243.12 219.75   L 243.12 220.46   L 243.12 221.75   L 243.12 222.46   Q 243.12 222.60 243.12 222.75   L 243.12 223.46   L 243.12 224.75   L 243.12 225.46   L 243.12 229.75   L 243.12 230.46   Q 243.12 230.60 243.12 230.75   L 243.12 231.46   L 243.12 232.75   L 243.12 233.46   L 243.12 234.75   L 243.12 235.46   Q 243.12 235.60 243.12 235.75   L 243.12 236.46   L 243.12 237.75   L 243.12 238.46   Q 243.12 238.60 243.12 238.75   L 243.12 239.46   L 243.12 241.75   L 243.12 242.46   L 243.12 243.75   L 243.12 244.46   L 243.12 245.75   L 243.12 246.46   Q 243.12 246.60 243.12 246.75   L 243.12 247.46   L 243.12 249.75   L 243.12 250.46   L 243.12 251.75   L 243.12 252.46   L 243.12 253.75   L 243.12 254.46   Q 243.12 254.60 243.12 254.75   L 243.12 255.46   L 243.12 257.75   L 243.12 258.46   Q 243.12 258.60 243.12 258.75   L 243.12 259.46   L 243.12 261.75   L 243.12 262.46   L 243.12 263.75   L 243.12 264.46   L 243.12 265.75   L 243.12 266.46   Q 243.12 266.60 243.12 266.75   L 243.12 267.46   L 243.12 269.75   L 243.12 270.46   L 243.12 271.75   L 243.12 272.46   L 243.12 273.75   L 243.12 274.46   Q 243.12 274.60 243.12 274.75   L 243.12 275.46   L 243.12 276.75   L 243.12 277.46   L 243.12 279.75   L 243.12 280.46   L 243.12 281.75   L 243.12 282.46   Q 243.12 282.60 243.12 282.75   L 243.12 283.46   L 243.12 287.75   L 243.12 288.46   L 243.12 289.75   L 243.12 290.46   Q 243.12 290.60 243.12 290.75   L 243.12 291.46   L 243.12 293.75   L 243.12 294.46   L 243.12 295.75   L 243.12 296.46   L 243.12 297.75   L 243.12 298.46   Q 243.12 298.60 243.12 298.75   L 243.12 299.46   L 243.12 301.75   L 243.12 302.46   L 243.12 303.75   L 243.12 304.46   L 243.12 305.75   L 243.12 306.46   Q 243.12 306.60 243.12 306.75   L 243.12 307.46   L 243.12 308.75   L 243.12 309.46   L 243.12 311.75   L 243.12 312.46   L 243.12 313.75   L 243.12 314.46   Q 243.12 314.60 243.12 314.75   L 243.12 315.46   L 243.12 316.75   L 243.12 317.46   L 243.12 319.75   L 243.12 320.46   L 243.12 321.75   L 243.12 322.46   Q 243.12 322.60 243.12 322.75   L 243.12 323.46   L 243.12 324.75   L 243.12 325.46   L 243.12 327.75   L 243.12 328.46   L 243.12 329.75   L 243.12 330.46   Q 243.12 330.60 243.12 330.75   L 243.12 331.46   L 243.12 333.75   L 243.12 334.46   L 243.12 335.75   L 243.12 336.46   L 243.12 337.75   L 243.12 338.46   Q 243.12 338.60 243.12 338.75   L 243.12 339.46   L 243.12 341.75   L 243.12 342.46   L 243.12 343.75   L 243.12 344.46   L 243.12 345.75   L 243.12 346.46   Q 243.12 346.60 243.12 346.75   L 243.12 347.46   L 243.12 349.75   L 243.12 350.46   L 243.12 351.75   L 243.12 352.46   L 243.12 353.75   L 243.12 354.46   Q 243.12 354.60 243.12 354.75   L 243.12 355.46   L 243.12 356.75   L 243.12 357.46   L 243.12 359.75   L 243.13 360.46   L 243.11 366.84   A 0.66 0.66 0.0 0 0 243.57 367.48   Q 265.50 374.42 275.39 394.85   C 285.71 416.17 278.69 442.15 260.52 456.29   C 236.38 475.08 201.22 468.45 185.57 441.94   C 176.01 425.74 176.31 405.36 186.23 389.47   Q 196.57 372.90 216.80 366.96   A 0.67 0.67 0.0 0 0 217.28 366.32   Q 217.24 361.12 217.25 139.25   Q 217.25 132.55 220.53 128.97   C 228.53 120.27 242.65 125.75 243.10 137.23   Q 243.16 138.72 243.12 143.75   Z"
      />
      <rect
        fill="#079be1"
        x={-4.55}
        y={-0.92}
        transform="translate(307.52,128.01) rotate(0.4)"
        width={9.1}
        height={1.84}
        rx={0.88}
      />
      <rect
        fill="#079be1"
        x={-8.87}
        y={-0.87}
        transform="translate(329.00,128.00) rotate(0.2)"
        width={17.74}
        height={1.74}
        rx={0.85}
      />
      <rect fill="#079be1" x={346.05} y={127.1} width={9.06} height={1.82} rx={0.88} />
      <path fill="#03608d" d="   M 243.12 144.46   L 243.12 143.75   L 243.12 144.46   Z" />
      <path fill="#03608d" d="   M 243.12 146.46   L 243.12 145.75   L 243.12 146.46   Z" />
      <path fill="#03608d" d="   M 243.12 148.46   L 243.12 147.75   L 243.12 148.46   Z" />
      <path fill="#03608d" d="   M 243.12 150.46   L 243.12 149.75   L 243.12 150.46   Z" />
      <path fill="#03608d" d="   M 243.12 151.46   L 243.12 150.75   L 243.12 151.46   Z" />
      <path fill="#03608d" d="   M 243.12 154.46   L 243.12 153.75   L 243.12 154.46   Z" />
      <path fill="#03608d" d="   M 243.12 156.46   L 243.12 155.75   L 243.12 156.46   Z" />
      <path fill="#03608d" d="   M 243.12 158.46   L 243.12 157.75   L 243.12 158.46   Z" />
      <path fill="#03608d" d="   M 243.12 159.46   L 243.12 158.75   L 243.12 159.46   Z" />
      <path fill="#03608d" d="   M 243.12 161.46   L 243.12 160.75   L 243.12 161.46   Z" />
      <path fill="#03608d" d="   M 243.12 164.46   L 243.12 163.75   L 243.12 164.46   Z" />
      <path fill="#03608d" d="   M 243.12 166.46   L 243.12 165.75   L 243.12 166.46   Z" />
      <path fill="#03608d" d="   M 243.12 169.46   L 243.12 168.75   L 243.12 169.46   Z" />
      <path fill="#03608d" d="   M 243.12 172.46   L 243.12 171.75   L 243.12 172.46   Z" />
      <path fill="#03608d" d="   M 243.12 174.46   L 243.12 173.75   L 243.12 174.46   Z" />
      <rect
        fill="#079be1"
        x={-3.64}
        y={-0.99}
        transform="translate(306.87,175.25) rotate(0.1)"
        width={7.28}
        height={1.98}
        rx={0.45}
      />
      <rect fill="#079be1" x={317.62} y={174.25} width={14.34} height={2} rx={0.37} />
      <rect
        fill="#079be1"
        x={-7.2}
        y={-0.99}
        transform="translate(346.31,175.25) rotate(-0.1)"
        width={14.4}
        height={1.98}
        rx={0.46}
      />
      <rect fill="#079be1" x={360.62} y={174.26} width={14.34} height={1.96} rx={0.36} />
      <rect
        fill="#079be1"
        x={-3.57}
        y={-0.99}
        transform="translate(385.69,175.25) rotate(-0.2)"
        width={7.14}
        height={1.98}
        rx={0.42}
      />
      <path fill="#03608d" d="   M 243.12 175.46   L 243.12 174.75   L 243.12 175.46   Z" />
      <path fill="#03608d" d="   M 243.12 180.46   L 243.12 179.75   L 243.12 180.46   Z" />
      <path fill="#03608d" d="   M 243.12 182.46   L 243.12 181.75   L 243.12 182.46   Z" />
      <path fill="#03608d" d="   M 243.12 183.46   L 243.12 182.75   L 243.12 183.46   Z" />
      <path fill="#03608d" d="   M 243.12 186.46   L 243.12 185.75   L 243.12 186.46   Z" />
      <path fill="#03608d" d="   M 243.12 188.46   L 243.12 187.75   L 243.12 188.46   Z" />
      <path fill="#03608d" d="   M 243.12 190.46   L 243.12 189.75   L 243.12 190.46   Z" />
      <path fill="#03608d" d="   M 243.12 191.46   L 243.12 190.75   L 243.12 191.46   Z" />
      <path fill="#03608d" d="   M 243.12 194.46   L 243.12 193.75   L 243.12 194.46   Z" />
      <path fill="#03608d" d="   M 243.12 196.46   L 243.12 195.75   L 243.12 196.46   Z" />
      <path fill="#03608d" d="   M 243.12 198.46   L 243.12 197.75   L 243.12 198.46   Z" />
      <path fill="#03608d" d="   M 243.12 199.46   L 243.12 198.75   L 243.12 199.46   Z" />
      <path fill="#03608d" d="   M 243.12 201.46   L 243.12 200.75   L 243.12 201.46   Z" />
      <path fill="#03608d" d="   M 243.12 204.46   L 243.12 203.75   L 243.12 204.46   Z" />
      <path fill="#03608d" d="   M 243.12 206.46   L 243.12 205.75   L 243.12 206.46   Z" />
      <path fill="#03608d" d="   M 243.12 207.46   L 243.12 206.75   L 243.12 207.46   Z" />
      <path fill="#03608d" d="   M 243.12 210.46   L 243.12 209.75   L 243.12 210.46   Z" />
      <path fill="#03608d" d="   M 243.12 212.46   L 243.12 211.75   L 243.12 212.46   Z" />
      <path fill="#03608d" d="   M 243.12 214.46   L 243.12 213.75   L 243.12 214.46   Z" />
      <path fill="#03608d" d="   M 243.12 215.46   L 243.12 214.75   L 243.12 215.46   Z" />
      <path fill="#03608d" d="   M 243.12 217.46   L 243.12 216.75   L 243.12 217.46   Z" />
      <path fill="#03608d" d="   M 243.12 220.46   L 243.12 219.75   L 243.12 220.46   Z" />
      <path fill="#03608d" d="   M 243.12 222.46   L 243.12 221.75   L 243.12 222.46   Z" />
      <path fill="#03608d" d="   M 243.12 223.46   L 243.12 222.75   L 243.12 223.46   Z" />
      <path fill="#03608d" d="   M 243.12 225.46   L 243.12 224.75   L 243.12 225.46   Z" />
      <rect fill="#079be1" x={303.21} y={225.87} width={8.7} height={2} rx={0.6} />
      <rect fill="#079be1" x={320.45} y={225.87} width={17.2} height={2} rx={0.59} />
      <rect fill="#079be1" x={346.21} y={225.87} width={8.7} height={2} rx={0.6} />
      <path fill="#03608d" d="   M 243.12 230.46   L 243.12 229.75   L 243.12 230.46   Z" />
      <path fill="#03608d" d="   M 243.12 231.46   L 243.12 230.75   L 243.12 231.46   Z" />
      <path fill="#03608d" d="   M 243.12 233.46   L 243.12 232.75   L 243.12 233.46   Z" />
      <path fill="#03608d" d="   M 243.12 235.46   L 243.12 234.75   L 243.12 235.46   Z" />
      <path fill="#03608d" d="   M 243.12 236.46   L 243.12 235.75   L 243.12 236.46   Z" />
      <path fill="#03608d" d="   M 243.12 238.46   L 243.12 237.75   L 243.12 238.46   Z" />
      <path fill="#03608d" d="   M 243.12 239.46   L 243.12 238.75   L 243.12 239.46   Z" />
      <path fill="#03608d" d="   M 243.12 242.46   L 243.12 241.75   L 243.12 242.46   Z" />
      <path fill="#03608d" d="   M 243.12 244.46   L 243.12 243.75   L 243.12 244.46   Z" />
      <path fill="#03608d" d="   M 243.12 246.46   L 243.12 245.75   L 243.12 246.46   Z" />
      <path fill="#03608d" d="   M 243.12 247.46   L 243.12 246.75   L 243.12 247.46   Z" />
      <path fill="#03608d" d="   M 243.12 250.46   L 243.12 249.75   L 243.12 250.46   Z" />
      <path fill="#03608d" d="   M 243.12 252.46   L 243.12 251.75   L 243.12 252.46   Z" />
      <path fill="#03608d" d="   M 243.12 254.46   L 243.12 253.75   L 243.12 254.46   Z" />
      <path fill="#03608d" d="   M 243.12 255.46   L 243.12 254.75   L 243.12 255.46   Z" />
      <path fill="#03608d" d="   M 243.12 258.46   L 243.12 257.75   L 243.12 258.46   Z" />
      <path fill="#03608d" d="   M 243.12 259.46   L 243.12 258.75   L 243.12 259.46   Z" />
      <path fill="#03608d" d="   M 243.12 262.46   L 243.12 261.75   L 243.12 262.46   Z" />
      <path fill="#03608d" d="   M 243.12 264.46   L 243.12 263.75   L 243.12 264.46   Z" />
      <path fill="#03608d" d="   M 243.12 266.46   L 243.12 265.75   L 243.12 266.46   Z" />
      <path fill="#03608d" d="   M 243.12 267.46   L 243.12 266.75   L 243.12 267.46   Z" />
      <path fill="#03608d" d="   M 243.12 270.46   L 243.12 269.75   L 243.12 270.46   Z" />
      <path fill="#03608d" d="   M 243.12 272.46   L 243.12 271.75   L 243.12 272.46   Z" />
      <path fill="#03608d" d="   M 243.12 274.46   L 243.12 273.75   L 243.12 274.46   Z" />
      <path fill="#03608d" d="   M 243.12 275.46   L 243.12 274.75   L 243.12 275.46   Z" />
      <path fill="#03608d" d="   M 243.12 277.46   L 243.12 276.75   L 243.12 277.46   Z" />
      <path fill="#03608d" d="   M 243.12 280.46   L 243.12 279.75   L 243.12 280.46   Z" />
      <path fill="#03608d" d="   M 243.12 282.46   L 243.12 281.75   L 243.12 282.46   Z" />
      <rect
        fill="#079be1"
        x={-3.63}
        y={-0.99}
        transform="translate(306.88,282.75) rotate(0.1)"
        width={7.26}
        height={1.98}
        rx={0.46}
      />
      <rect
        fill="#079be1"
        x={-7.19}
        y={-1}
        transform="translate(324.80,282.75) rotate(-0.1)"
        width={14.38}
        height={2}
        rx={0.42}
      />
      <rect
        fill="#079be1"
        x={-7.19}
        y={-0.99}
        transform="translate(346.32,282.75) rotate(-0.1)"
        width={14.38}
        height={1.98}
        rx={0.48}
      />
      <rect
        fill="#079be1"
        x={-7.18}
        y={-0.99}
        transform="translate(367.80,282.75) rotate(-0.1)"
        width={14.36}
        height={1.98}
        rx={0.41}
      />
      <rect
        fill="#079be1"
        x={-3.58}
        y={-0.99}
        transform="translate(385.70,282.76) rotate(-0.1)"
        width={7.16}
        height={1.98}
        rx={0.46}
      />
      <path fill="#03608d" d="   M 243.12 283.46   L 243.12 282.75   L 243.12 283.46   Z" />
      <path fill="#03608d" d="   M 243.12 288.46   L 243.12 287.75   L 243.12 288.46   Z" />
      <path fill="#03608d" d="   M 243.12 290.46   L 243.12 289.75   L 243.12 290.46   Z" />
      <path fill="#03608d" d="   M 243.12 291.46   L 243.12 290.75   L 243.12 291.46   Z" />
      <path fill="#03608d" d="   M 243.12 294.46   L 243.12 293.75   L 243.12 294.46   Z" />
      <path fill="#03608d" d="   M 243.12 296.46   L 243.12 295.75   L 243.12 296.46   Z" />
      <path fill="#03608d" d="   M 243.12 298.46   L 243.12 297.75   L 243.12 298.46   Z" />
      <path fill="#03608d" d="   M 243.12 299.46   L 243.12 298.75   L 243.12 299.46   Z" />
      <path fill="#03608d" d="   M 243.12 302.46   L 243.12 301.75   L 243.12 302.46   Z" />
      <path fill="#03608d" d="   M 243.12 304.46   L 243.12 303.75   L 243.12 304.46   Z" />
      <path fill="#03608d" d="   M 243.12 306.46   L 243.12 305.75   L 243.12 306.46   Z" />
      <path fill="#03608d" d="   M 243.12 307.46   L 243.12 306.75   L 243.12 307.46   Z" />
      <path fill="#03608d" d="   M 243.12 309.46   L 243.12 308.75   L 243.12 309.46   Z" />
      <path fill="#03608d" d="   M 243.12 312.46   L 243.12 311.75   L 243.12 312.46   Z" />
      <path fill="#03608d" d="   M 243.12 314.46   L 243.12 313.75   L 243.12 314.46   Z" />
      <path fill="#03608d" d="   M 243.12 315.46   L 243.12 314.75   L 243.12 315.46   Z" />
      <path fill="#03608d" d="   M 243.12 317.46   L 243.12 316.75   L 243.12 317.46   Z" />
      <path fill="#03608d" d="   M 243.12 320.46   L 243.12 319.75   L 243.12 320.46   Z" />
      <path fill="#03608d" d="   M 243.12 322.46   L 243.12 321.75   L 243.12 322.46   Z" />
      <path fill="#03608d" d="   M 243.12 323.46   L 243.12 322.75   L 243.12 323.46   Z" />
      <path fill="#03608d" d="   M 243.12 325.46   L 243.12 324.75   L 243.12 325.46   Z" />
      <path fill="#03608d" d="   M 243.12 328.46   L 243.12 327.75   L 243.12 328.46   Z" />
      <path fill="#03608d" d="   M 243.12 330.46   L 243.12 329.75   L 243.12 330.46   Z" />
      <path fill="#03608d" d="   M 243.12 331.46   L 243.12 330.75   L 243.12 331.46   Z" />
      <path fill="#03608d" d="   M 243.12 334.46   L 243.12 333.75   L 243.12 334.46   Z" />
      <path fill="#03608d" d="   M 243.12 336.46   L 243.12 335.75   L 243.12 336.46   Z" />
      <path fill="#03608d" d="   M 243.12 338.46   L 243.12 337.75   L 243.12 338.46   Z" />
      <path fill="#03608d" d="   M 243.12 339.46   L 243.12 338.75   L 243.12 339.46   Z" />
      <path fill="#03608d" d="   M 243.12 342.46   L 243.12 341.75   L 243.12 342.46   Z" />
      <path fill="#03608d" d="   M 243.12 344.46   L 243.12 343.75   L 243.12 344.46   Z" />
      <path fill="#03608d" d="   M 243.12 346.46   L 243.12 345.75   L 243.12 346.46   Z" />
      <path fill="#03608d" d="   M 243.12 347.46   L 243.12 346.75   L 243.12 347.46   Z" />
      <path fill="#03608d" d="   M 243.12 350.46   L 243.12 349.75   L 243.12 350.46   Z" />
      <path fill="#03608d" d="   M 243.12 352.46   L 243.12 351.75   L 243.12 352.46   Z" />
      <path fill="#03608d" d="   M 243.12 354.46   L 243.12 353.75   L 243.12 354.46   Z" />
      <path fill="#03608d" d="   M 243.12 355.46   L 243.12 354.75   L 243.12 355.46   Z" />
      <path fill="#03608d" d="   M 243.12 357.46   L 243.12 356.75   L 243.12 357.46   Z" />
      <path fill="#03608d" d="   M 243.13 360.46   L 243.12 359.75   L 243.13 360.46   Z" />
    </Box>
  );
};
